import React, { Component, ReactNode } from 'react'

type ContentMainLayout = 'full' | 'half' | 'oneThird' | 'twoThird'
type ContentMainLayouts = Record<ContentMainLayout, string>

interface ContentMainProps {
  layout: ContentMainLayout
  className?: string
  children: ReactNode
}

export default class ContentMain extends Component<ContentMainProps> {
  layouts: ContentMainLayouts = {
    full: 'w-full',
    half: 'w-full lg:w-1/2',
    oneThird: 'w-full lg:w-1/3',
    twoThird: 'w-full lg:w-2/3'
  }

  get className () {
    const { layout, className } = this.props
    return `${this.layouts[layout]} ${className}`
  }

  render () {
    return (
      <div className={this.className}>
        {this.props.children}
      </div>
    )
  }
}
